import { inject, Injectable } from '@angular/core';

import { ROUTES } from '@core/constants';
import { CapturedPhoto, EvidenceType } from '@core/models';
import { ApiService } from '@core/services';
import { UploadsService } from '@core/services/uploads/uploads.service';

@Injectable({
  providedIn: 'root',
})
export class ReQuoteService {
  private readonly api = inject(ApiService);
  private readonly uploadsService = inject(UploadsService);

  async createReQuote(payload: {
    orderId: string;
    observations: string;
    urls: string[];
  }): Promise<void> {
    await this.api.post(ROUTES.OPS_REQUOTE_CREATE, payload);
    return;
  }

  async uploadReQuoteEvidence(
    orderId: string,
    photos: CapturedPhoto[],
  ): Promise<string[]> {
    const presigned = await this.uploadsService.getPresignedUrls({
      orderId,
      type: EvidenceType.NEWS,
      files: photos.map((photo) => ({ fileName: photo.fileName })),
    });
    if (presigned.length !== photos.length) {
      throw new Error(
        'No se recibió URL firmada para la evidencia de servicios faltantes.',
      );
    }

    return this.uploadsService.uploadReceptionEvidences(presigned, photos);
  }
}
